
import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  withCredentials: true, // Enables cookies for authentication
});

// ✅ Attach token to every request
API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});
// ✅ Authentication APIs
export const login = (formData) => API.post("/auth/login", formData);
export const register = (formData) => API.post("/auth/register", formData);

// ✅ Blog APIs
export const fetchBlogs = () => API.get("/blogs");
export const createBlog = (blogData) => API.post("/blogs", blogData);

// ✅ Contact API
export const sendMessage = (messageData) => API.post("/contact", messageData);

// ✅ User Management APIs (for Admin Panel)
export const fetchUsers = () => API.get("/users"); // Fetch all users (Admin)
export const addUser = (userData) => API.post("/users", userData); // Add new user (Admin)
export const updateUser = (id, userData) => API.put(`/users/${id}`, userData); // Update user
export const deleteUser = (id) => API.delete(`/users/${id}`); // Delete user

export default API;
